const logoLoaders = {
  10: () => import("../images/pitc.png"),
  11: () => import("../images/DISCO Logos/LESCO.png"),
  12: () => import("../images/DISCO Logos/GEPCO.png"),
  13: () => import("../images/DISCO Logos/FESCO.png"),
  14: () => import("../images/DISCO Logos/IESCO.png"),
  15: () => import("../images/DISCO Logos/MEPCO.png"),
  26: () => import("../images/DISCO Logos/PESCO.png"),
  27: () => import("../images/discologos/hazeco_logo-removebg-preview.png"),
  37: () => import("../images/DISCO Logos/HESCO.png"),
  38: () => import("../images/DISCO Logos/SEPCO.png"),
  48: () => import("../images/DISCO Logos/QESCO.png"),
  59: () => import("../images/DISCO Logos/TESCO.png"),
  91: () => import("../images/discologos/sundar-logo.png"),
};

const watermarkLoaders = {
  11: () => import("../images/DiscosWater/lescowatermark.png"),
  12: () => import("../images/DiscosWater/gepco-watermark.png"),
  13: () => import("../images/DiscosWater/fesco-watermark.png"),
  14: () => import("../images/DiscosWater/iescowatermark.png"),
  15: () => import("../images/DiscosWater/mepcco-watermark.png"),
  26: () => import("../images/DiscosWater/pesco-watermark.png"),
  27: () => import("../images/DiscosWater/hazeco-watermark.png"),
  37: () => import("../images/DiscosWater/hesco-watermark.png"),
  38: () => import("../images/DiscosWater/sepco-watermark.png"),
  48: () => import("../images/DiscosWater/qesco-watermark.png"),
  59: () => import("../images/DiscosWater/tesco-watermark.png"),
};

const assetCache = new Map();

const loadAsset = async (loaders, code, fallbackCode) => {
  try {
    const key = String(code || fallbackCode);
    const cacheKey = `${fallbackCode}:${key}`;
    if (assetCache.has(cacheKey)) {
      return assetCache.get(cacheKey);
    }
    const loader = loaders[key] || loaders[fallbackCode];
    if (typeof loader !== "function") {
      return "";
    }
    const mod = await loader();
    const src = mod?.default || "";
    if (src) {
      assetCache.set(cacheKey, src);
    }
    return src;
  } catch {
    return "";
  }
};

export const loadDiscoLogo = (code) => loadAsset(logoLoaders, code, "15");

export const loadDiscoWatermark = (code) =>
  loadAsset(watermarkLoaders, code, "15");

export const loadEopsPng = () =>
  loadAsset({ eops: () => import("../images/eops.png") }, "eops", "eops");
